import { Link } from "react-router-dom";
import ViewHeader from "../Layouts/ViewHeader/ViewHeader";

export default function Instructions() {
    return (
        <ViewHeader>
            <p><u><em>How to use this feature:</em></u></p>
            <ul>
                <li>Navigate to either CDE Catalog or CRF LIbrary</li>
                <li>Filter down to your selections</li>
                <li>Check the box next to the CDEs or CRFs you wish to use.</li>
                <li>In the operations box choose <strong><em>Add Selected to Formbuilder</em></strong></li>
                <li>Add more with other searches or head back here to the FormBuilder Cart Tab</li>
            </ul>
            <p><Link to="/cde-catalog">Add fields from CDE Catalog</Link></p>
            <p><Link to="/crf-library">Add Standard template from CRF Library</Link></p>
        </ViewHeader>
    );
}